import classNames from 'classnames';
import React from 'react';

import VulnerabilityExternalLink from '../../types/VulnerabilityExternalLink';
import styles from './detailsItem.scss';

type DetailsItemInfo = number | string | string[] | VulnerabilityExternalLink[] | null;

type Props = {
  id: string;
  index: number;
  name: string;
  info: DetailsItemInfo;
};

const DetailsItem: React.FC<Props> = (props) => {
  const renderInfo = () => {
    switch (props.name.toLowerCase()) {
      // Array of strings.
      case 'cves':
      case 'additional_affected_asset_fields':
        return (
          <ul>
            {(props.info as string[]).map((value, index) => (
              <li key={index}>&#x2022; {value}</li>
            ))}
          </ul>
        );

      // Array of { url:string, title:string }
      case 'external_links':
        return (
          <ul>
            {(props.info as VulnerabilityExternalLink[]).map((externalLink, index) => (
              <li key={index}>
                &#x2022; {externalLink.title} -{' '}
                <a href={externalLink.url} target="_blank" rel="noreferrer">
                  {externalLink.url}
                </a>
              </li>
            ))}
          </ul>
        );

      // Strings and numbers.
      default:
        return <>{props.info ?? 'null'}</>;
    }
  };

  return (
    <div
      id={props.id}
      data-testid={props.id}
      className={classNames(styles['details-item'], props.index % 2 === 0 ? styles['details-item_light'] : styles['details-item_dark'])}
    >
      <div className={styles['name']}>{props.name}:</div>
      <div className={styles['info']}>{renderInfo()}</div>
    </div>
  );
};

export default DetailsItem;
